import { FakeLink, TextLink } from '../TextLink';
import type { BackButtonFragment } from '@/utils/dato/generated';

const BackButton = ({ text = 'Go Back', link }: BackButtonFragment) => (
  <div className="mb-6">
    {link ? (
      <TextLink className="no-underline flex justify-center" href={link}>
        <span className="material-symbols-outlined mr-1">chevron_left</span> {text}
      </TextLink>
    ) : (
      <FakeLink className="!no-underline flex justify-center" onClick={() => window.history.back()}>
        <span className="material-symbols-outlined mr-1">chevron_left</span> {text}
      </FakeLink>
    )}
  </div>
);

export default BackButton;
